import React from 'react';

import './index.styles.scss';

export const LoginScreen = () => {
  return <div></div>;
};
